<template>
  <router-view></router-view>
</template>
<script lang="js" setup>
import { ref ,onMounted} from "vue";
import http from "@/api"
const baseData = ref({
    enterprise_name_en:'',
    enterprise_name: '',
    enterprise_logo: '',
    bg_pic: '',
    medias: [],//轮播图
    enterprise_slogan: '',//公司广告语
  })
  const resType = ref({
    message: '',
    time: '',
    times: '',
    type: ""
  })
  // 立即执行函数表达式 (IIFE)，确保代码在全局作用域中独立运行

  // 这个函数用于计算并设置 <html> 的 font-size
  function calcFontSize() {
    // 获取当前设备宽度
    const deviceWidth = document.documentElement.clientWidth;
    
    // 根据设计稿的宽度比例计算出合适的 font-size
    const baseFontSize = 75; // 基于750px设计稿的基准值
    const designWidth = 750; // 设计稿的宽度
    
    // 设置 <html> 的 font-size，确保页面内容按比例缩放
    document.documentElement.style.fontSize = `${baseFontSize * (deviceWidth / designWidth)}px`;
    
    console.log(`Device width: ${deviceWidth}px, Setting html font-size to: ${document.documentElement.style.fontSize}`);
  }
  
  calcFontSize();
  
  // 当窗口大小变化时，再次调用 calcFontSize 函数以更新 <html> 的 font-size
  window.addEventListener('resize', calcFontSize);

const isLoading = ref(true)
const loading = ref(false)
const template = ref('')
function GetUrlParam(paraName) {
    let url = document.location.toString();
    let arrObj = url.split("?");
    if (arrObj.length > 1) {
      let arrPara = arrObj[1].split("&");
      let arr;
      for (let i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");
        if (arr != null && arr[0] == paraName) {
          return arr[1];
        }
      }
      return "";
    }
    else {
      return "";
    }
  }
const inputValue = ref('')
const domain_info = ref({})
const batch_info = ref({})
const search = () => {
  if (!inputValue.value) {
    ElMessageBox.confirm("请输入防伪码", "提示", {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
    isLoading.value = false
    return
  }
  loading.value = true
  http.get(`/qrcode_search/${inputValue.value}`).then((res) => {
    console.log("res",res)
    domain_info.value = res.data.domain_info ? res.data.domain_info : {}
    batch_info.value = res.data.batch_info ? res.data.batch_info : {}
    console.log(" domain_info", domain_info)
    console.log(" batch_info", batch_info)
    template.value = res.data.data.template
    // isShowResult.value = true
    resType.value.message = res.data.msg
    resType.value.type = res.data.status
    res.data.data &&  (baseData.value = res.data.data)
  }).finally(() => {
    isLoading.value = false
//   const res = {
//     data:{
//     "status": "success",
//     "msg": "您好，您所查询的是MX生产的正牌产品，请放心使用！您所查询的防伪码已被查询63次，首次查询时间为：2025-08-25 15:07:11，当前二维码为：1148414664161854，如不是您亲自查询，谨防假冒！",
//     "data": {
//         "id": "55ca1a12-e8bc-4721-8039-cc72184353e8",
//         "created_at": "2025-08-22 00:03:51.692175+00:00",
//         "updated_at": "2025-08-25 07:15:27.076270+00:00",
//         "enterprise_code": "MX",
//         "enterprise_name": "MX",
//         "enterprise_name_en": "MX",
//         "legal_name": "MX",
//         "legal_phone": "MX",
//         "principal_name": "MX",
//         "principal_phone": "@MX",
//         "business_license": "",
//         "tax_registration": "",
//         "authorization_license": "",
//         "trademark_license": "",
//         "other_license": "",
//         "enterprise_logo": "https://fangwei123.shop/media/logos/0.png",
//         "enterprise_slogan": "过去已去,未来已来",
//         "enterprise_brief": "美心集团为香港最大的饮食集团，总部设于香港，美心的多元化饮食服包括贺年糕品、端午粽子、腊肠腊味及中秋月饼等。 美心月饼的品质亦受“Q唛”优质产品证书及国际认可的HACCP“食品安全重点控制”证书肯定，并荣获Monde Selection“世界精选”优质食品“超级金奖”荣誉，据ACNeilsen市场调查，连续十一年（1997-2008年）成为全港销量冠军。 香港美心月饼全部香港新鲜制造，不含猪油，保证优质产品。",
//         "bg_pic": "https://fangwei123.shop/media/bkpics/0_6iir5r2.png",
//         "max_error_count": "100",
//         "template": "template4",
//         "medias": [
//             "https://fangwei123.shop/media/enterprise_medias/0.png"
//         ]
//     },
//     "batch_info": {
//         "specification": "无",
//         "artno": "无",
//         "batchno": "无",
//         "produce_date": "2025-08-24T03:27:00Z",
//         "period": 12,
//         "period_date": "2026-08-24T03:27:00Z",
//         "first_sacn_time": ""
//     },
//     "domain_info": {
//         "prefix": "https://easinlee.eetgb.com/",
//         "pic": "https://easinlee.eetgb.com//media/pics/Snipaste_2025-08-24_19-20-40.jpg",
//         "colors": [
//             "255,0,0",
//             "0,0,0",
//             "0,0,255",
//             "0,255,0"
//         ]
//     }
// }
//   }
  // domain_info.value = res.data.domain_info ? res.data.domain_info : {}
  //   batch_info.value = res.data.batch_info ? res.data.batch_info : {}
  //   console.log(" domain_info", domain_info)
  //   console.log(" batch_info", batch_info)
  //   template.value = res.data.data.template
  //   // isShowResult.value = true
  //   resType.value.message = res.data.msg
  //   resType.value.type = res.data.status
  //   res.data.data &&  (baseData.value = res.data.data)
    loading.value = false
  })
}
const getDetail = (code) => {
   http.get(`/enterprise_search/?code=${code}`).then(res=>{
     // console.log("res",res)
     template.value = res.data.template
     baseData.value = res?.data || {}
   }).catch(()=>{
   
   }).finally(()=>{
    isLoading.value = false
   })
 }
 const code = ref('')
onMounted(() => {
  // code.value = GetUrlParam("code") || ''
  // if(code.value == 'QYKJ'){
  //    document.title='微原防伪溯源系统'
  // }
  // inputValue.value = GetUrlParam("qid") || ''
  // if( inputValue.value){
  //   search()
  // }else if(GetUrlParam('code')){
  //   getDetail(GetUrlParam('code'))
  // }else{
  //   // template.value = 'template4'
  //   template.value = 'template_common1'
  //   // console.log(" isLoading.value", isLoading.value)
  //   isLoading.value = false
  //   // console.log(" isLoading.value", isLoading.value)
  // }
})
</script>
<style lang="scss">
html,
body,
p {
  margin: 0px;
  padding: 0px;
}

</style>
